import type { AdditionalResource } from '../types/additionalResource';
import type { CustomizationType } from '../types/customizationTypes';

type getSharedAttributesProps = {
	customization?: CustomizationType;
	additionalResources?: AdditionalResource[];
	playbackSpeed: number;
	hasFetched: boolean;
};

export const getSharedAttributes = ({
	customization,
	additionalResources,
	playbackSpeed,
	hasFetched,
}: getSharedAttributesProps) => {
	if (!customization || !additionalResources) {
		return {};
	}

	return {
		tone: customization.tone,
		length: customization.length,
		sourceCount: additionalResources.length,
		playbackSpeed,
		hasFetchedBriefing: hasFetched,
	};
};
